import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { SocialLink } from '../../footer/AdditionalFooterSections/FooterSocialLinks';
import { Link } from '../../../../partials/link/Link';
import { useTheme } from '../../../../../theming/useTheme';
import { BaseUnit } from '../../../../../theming/baseUnitDefinition';
import { MEDIA_BREAKPOINTS } from '../../../../../mediaQueries.const';

interface SocialLinksProps {
  socialLinks: SocialLink[];
  verticalGapInLargeScreen: number;
  verticalGapInMediumScreen: number;
}

const getStyles = (baseUnit: BaseUnit, numSocialLinks: number, verticalGapInLargeScreen: number, verticalGapInMediumScreen: number) => StyleSheet.create({
  wrapper: {
    gridTemplateColumns: `repeat(${numSocialLinks}, 1fr)`,
    alignItems: 'center',
    textAlign: 'center',
    [MEDIA_BREAKPOINTS.large]: {
      display: 'grid',
      paddingLeft: `${baseUnit * verticalGapInLargeScreen}px`,
      gridColumnGap: `${baseUnit * verticalGapInLargeScreen}px`,
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: 'grid',
      paddingLeft: `${baseUnit * verticalGapInMediumScreen}px`,
      gridColumnGap: `${baseUnit * verticalGapInMediumScreen}px`,
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: 'none',
    },
  },
});

export const SocialLinks: React.FunctionComponent<SocialLinksProps> = props => {
  const { socialLinks, verticalGapInLargeScreen, verticalGapInMediumScreen } = props;
  const { baseUnit } = useTheme();
  const styles = getStyles(baseUnit, socialLinks.length, verticalGapInLargeScreen, verticalGapInMediumScreen);
  return (
    <div className={css(styles.wrapper)}>
      {
        socialLinks.map((link, index) => (
          <Link href={link.href} key={index}>
            <img src={link.src} alt={link.alt} />
          </Link>
        ))
      }
    </div>
  );
};
